export const horizontalScroll = () => {
  const containers = document.querySelectorAll('.js-horizontal-scroll');

  const updateScrollState = (scrollElement: HTMLElement, container: HTMLElement) => {
    container.dataset.scrollStart = 'false';
    container.dataset.scrollEnd = 'false';

    if (scrollElement.scrollLeft == 0) {
      container.dataset.scrollStart = 'true';
    }

    if (scrollElement.scrollLeft == scrollElement.scrollWidth - scrollElement.clientWidth) {
      container.dataset.scrollEnd = 'true';
    }
  };

  containers.forEach((container) => {
    const overflowElement = container.children[0] as HTMLElement;

    overflowElement.addEventListener('scroll', () => {
      updateScrollState(overflowElement, container as HTMLElement);
    });

    updateScrollState(overflowElement, container as HTMLElement);
  });
};
